export const UiCardSpreadClasses = {
    sm: '-m-4 p-4',
    md: '-m-4 p-4 md:-mx-6 md:p-6',
    lg: '-m-4 p-6 md:-mx-8 md:p-8'
}

export const UiCardPaddingClasses = {
    sm: 'p-4',
    md: 'p-4 md:p-6',
    lg: 'p-6 md:p-8'
}

export const UiCardRadiusClasses = {
    sm: 'rounded-lg',
    md: 'rounded-xl'
}
